import type { QueryClient } from "@tanstack/react-query";
import { EntryType, MediaGroup } from "@/openapi/generated/models";
import { fetchMediaAsset } from "@/lib/utils/media/fetch-media-asset";
import { getMediaAssetQueryKey } from "@/lib/utils/media/media-asset-query-key";
import { PUBLIC_PRESIGNED_URL_STALE_MS } from "@/lib/utils/media/public-media-cache";

export async function prefetchTenantLogoPublic(
  queryClient: QueryClient,
  tenantId: number,
) {
  if (tenantId <= 0) return queryClient;

  await queryClient.prefetchQuery({
    queryKey: getMediaAssetQueryKey(
      tenantId,
      EntryType.Tenant,
      tenantId,
      MediaGroup.Logo,
      "public",
    ),
    queryFn: () =>
      fetchMediaAsset({
        tenantId,
        ownerType: EntryType.Tenant,
        ownerId: tenantId,
        mediaGroup: MediaGroup.Logo,
      }).catch(() => ({
        url: null,
        mediaId: null,
        media: null,
      })),
    staleTime: PUBLIC_PRESIGNED_URL_STALE_MS,
  });

  return queryClient;
}
